import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { SrmMenuService } from "@shared/components/srm-menu/srm-menu.service";
import { CommonsService } from "@core/service/commons.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-srm-menu',
  templateUrl: './srm-menu.component.html',
  styles: []
})
export class SrmMenuComponent implements OnInit {
  @Input() menuTitle; //菜单名
  @Input() menuCode; //菜单code
  @Input() menuParamString:string;//菜单查询条件
  @Input() menuIcon:string;//菜单图标type值
  public nodes:any = [];
  @Output() private childOuter = new EventEmitter();
  clickNode(event){
    /**
     *menuType值
     * 1：供应商视图中的供应商资料
     *
     * */
    this.childOuter.emit(event);
  }
  constructor(private srmMenuService:SrmMenuService,public commonsService:CommonsService,public routers:Router) { }
  //判断路由地址是否为当前路由
  routerIsSelect(str){
    return this.routers.url.indexOf(str) != -1;
  }

  public loading:boolean = false;
  getMenuList(){
    let obj = {};
    if(this.menuParamString){
      obj = {
        code:this.menuCode,
        param:this.menuParamString
      }
    }else{
      obj = {
        code:this.menuCode
      }
    }
    this.loading = true;
    this.srmMenuService.getMenuList(obj).subscribe((data) =>{
      this.nodes = data;
      this.loading = false;
    },() => this.loading = false);
  }
  ngOnInit() {
    this.getMenuList();
  }

}
